import { marker as _ } from '@biesbjerg/ngx-translate-extract-marker';
import {
    DataService,
    DeletionResult,
    isMultiChannel,
    ModalService,
    NotificationService,
    Permission,
    Product,
    registerBulkAction,
} from '@vendure/admin-ui/core';
import { unique } from '@vendure/common/lib/unique';
import { gql } from 'graphql-tag';
import { EMPTY } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { AssignProductsToChannel } from './components/assign-products-to-channel-dialog/assign-products-to-channel-dialog.component';
import { AssignProductsToFacetsDialog } from './components/assign-facets-to-channel/assign-facets-to-bulk-channels-dialog.component';

export default [
    registerBulkAction({
        location: 'product-list',
        label: 'Bulk Assign to Stores',
        icon: 'layers',
        requiresPermission: userPermissions =>
            userPermissions.includes(Permission.UpdateCatalog) ||
            userPermissions.includes(Permission.UpdateProduct),
        isVisible: ({ injector }) => isMultiChannel(injector.get(DataService)),
        onClick: ({ injector, selection, clearSelection }) => {
            const ProductsGQL = gql`
                query GetProductsForBulkAction($options: ProductListOptions!) {
                    products(options: $options) {
                        items {
                            id
                            name
                            channels {
                                id
                                code
                            }
                        }
                    }
                }
            `;
            const modalService = injector.get(ModalService);
            const dataService = injector.get(DataService);
            const channelIdsSet = new Set<string>();

            // Fetch products and channels
            dataService
                .query(ProductsGQL, {
                    options: {
                        filter: {
                            id: { in: unique(selection.map(p => p.id)) },
                        },
                    },
                })
                .mapSingle((data: any) => data.products.items)
                .subscribe((products: Product[]) => {
                    products.forEach(product => {
                        product.channels.forEach(channel => {
                            channelIdsSet.add(channel.id);
                        });
                    });

                    // Open the modal after channels are fetched
                    modalService
                        .fromComponent(AssignProductsToChannel, {
                            size: 'lg',
                            locals: {
                                productIds: unique(selection.map(p => p.id)),
                                currentChannelIds: Array.from(channelIdsSet),
                            },
                        })
                        .subscribe(result => {
                            if (result) {
                                clearSelection();
                            }
                        });
                });
        },
    }),
    registerBulkAction({
        location: 'facet-list',
        label: 'Assign to bulk stores',
        icon: 'tag', // choose an icon that makes sense
        requiresPermission: userPermissions =>
            userPermissions.includes(Permission.UpdateCatalog) ||
            userPermissions.includes(Permission.UpdateProduct),
        isVisible: () => true,
        onClick: ({ injector, selection, clearSelection }) => {
            const modalService = injector.get(ModalService);
            const facetIdsSet = new Set<string>();
                modalService
                            .fromComponent(AssignProductsToFacetsDialog, {
                                size: 'lg',
                                locals: {
                                    productIds: unique(selection.map(p => p.id)),
                                    currentFacetIds: Array.from(facetIdsSet),
                                },
                            })
                            .subscribe(result => {
                                if (result) {
                                    clearSelection();
                                }
                            });
        },
    }),
];
